import React from "react";
import "./ApiDetails.css";
import { APIDetailsHeader } from "../common/ApiDetailsTabHeader.js";

const DEVELOPER_CARE_PORTAL_URL = "https://developer.cdkcare.com/";
const REGISTER_AS_NEW_USER_URL = "https://developer.cdkcare.com/s/login/login/SelfRegister";

const BundleSupport = () => {
  return (
    <>
      <APIDetailsHeader title="Bundle Contacts" />
      <div
        className="api-dir-pkg_bundle_contacts_text_description"
        data-cy="contact-description"
      >
        For more support with this bundle or other bundles, please reach out to
        us through the{" "}
        <a
          href={DEVELOPER_CARE_PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Developer Care Portal
        </a>
        . If you do not have a Developer Care Portal account, click this link{" "}
        <a
          href={REGISTER_AS_NEW_USER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Register as a New User
        </a>

      </div>
    </>
  );
};

export default BundleSupport;
